// Kashier Payment Gateway Configuration

// Debug environment variables
console.log('🔧 Kashier Config Debug:', {
  MERCHANT_ID_ENV: process.env.REACT_APP_KASHIER_MERCHANT_ID,
  API_KEY_ENV: process.env.REACT_APP_KASHIER_API_KEY,
  BASE_URL_ENV: process.env.REACT_APP_KASHIER_BASE_URL,
  ENVIRONMENT_ENV: process.env.REACT_APP_KASHIER_ENVIRONMENT
});

export const KASHIER_CONFIG = {
  // Base URLs for iFrame integration
  BASE_URL: process.env.REACT_APP_KASHIER_BASE_URL || 'https://checkout.kashier.io',
  SANDBOX_URL: 'https://checkout.kashier.io',
  PRODUCTION_URL: 'https://checkout.kashier.io',
  
  // API Endpoints
  ENDPOINTS: {
    CREATE_PAYMENT: '/payment',
    GET_PAYMENT_STATUS: '/payment/status',
    CREATE_REFUND: '/refund',
    WEBHOOK: '/webhooks/kashier'
  },
  
  // Configuration - Using provided merchant ID
  MERCHANT_ID: process.env.REACT_APP_KASHIER_MERCHANT_ID || 'MID-38818-328',
  API_KEY: process.env.REACT_APP_KASHIER_API_KEY || 'ad7432c6-46aa-4e04-bd7d-79d6a5e9ef0b',
  WEBHOOK_SECRET: process.env.REACT_APP_KASHIER_WEBHOOK_SECRET || 'test_webhook_secret',
  ENVIRONMENT: (process.env.REACT_APP_KASHIER_ENVIRONMENT as 'test' | 'live') || 'test',
  
  // Currency and Language
  CURRENCY: 'EGP',
  LANGUAGE: 'en',
  
  // Payment Methods
  PAYMENT_METHODS: {
    CARD: 'card',
    WALLET: 'wallet',
    BANK_TRANSFER: 'bank_transfer',
    QR: 'qr'
  },
  
  // Transaction Status
  STATUS: {
    SUCCESS: 'SUCCESS',
    FAILED: 'FAILED',
    PENDING: 'PENDING',
    CANCELLED: 'CANCELLED'
  },
  
  // Environment-specific settings
  get isProduction() {
    return this.ENVIRONMENT === 'live';
  },
  
  get baseUrl() {
    return this.isProduction ? this.PRODUCTION_URL : this.SANDBOX_URL;
  },
  
  get headers() {
    return {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.API_KEY}`,
      'X-Merchant-ID': this.MERCHANT_ID,
      'X-Environment': this.ENVIRONMENT
    };
  }
};

// Debug final config values
console.log('🔧 Kashier Config Final Values:', {
  MERCHANT_ID: KASHIER_CONFIG.MERCHANT_ID,
  API_KEY: KASHIER_CONFIG.API_KEY,
  BASE_URL: KASHIER_CONFIG.baseUrl,
  ENVIRONMENT: KASHIER_CONFIG.ENVIRONMENT
});

// Validation function
export const validateKashierConfig = (): { isValid: boolean; errors: string[] } => {
  const errors: string[] = [];
  
  if (!KASHIER_CONFIG.MERCHANT_ID) {
    errors.push('KASHIER_MERCHANT_ID is required');
  }
  
  if (!KASHIER_CONFIG.API_KEY) {
    errors.push('KASHIER_API_KEY is required');
  }
  
  if (!KASHIER_CONFIG.WEBHOOK_SECRET) {
    errors.push('KASHIER_WEBHOOK_SECRET is required');
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
};

// Helper functions
export const getKashierUrl = (endpoint: string): string => {
  return `${KASHIER_CONFIG.baseUrl}${endpoint}`;
};

export const getWebhookUrl = (): string => {
  return `${window.location.origin}/api/webhooks/kashier`;
};

export const getSuccessUrl = (sessionId: string): string => {
  return `${window.location.origin}/payment/success?session_id=${sessionId}`;
};

export const getFailureUrl = (sessionId: string): string => {
  return `${window.location.origin}/payment/failure?session_id=${sessionId}`;
};
